export default {
  header: {
    title: 'Acquista gift card',
  },
  checkout_btn: {
    title: 'Checkout',
    max_quantity: 'Al massimo {{max}} carte regalo per acquisto',
  },
  items: {
    gift_card: {
      online: 'Gift card riscattabile solo online',
      online_and_store: 'Gift card (riscattabile online e in negozio)',
      title: "Seleziona l'importo desiderato",
      description: 'Aggiungi la gift card con la quantità desiderata al carrello',
    },
    expiration: {
      label: 'Valida per 3 anni',
      title: 'Buon regalo!',
      description: 'Il destinatario può riscattare il buono in modo flessibile entro 3 anni.',
    },
    delivery: {
      label: 'Consegna immediata come PDF via email',
      title: 'Consegna istantanea come PDF via email',
      description: 'Dopo il pagamento sicuro riceverai il buono immediatamente.',
    },
  },
  form: {
    value: {
      title: "Scegli l'importo della gift card",
      custom: {
        label: 'Personalizzato',
        placeholder: 'Inserisci un importo tra {{min}} e {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Quantità',
    },
    email: {
      title: 'Qual è la tua email per ricevere la gift card?',
      placeholder: 'Il tuo indirizzo email',
      error: 'Email non valida',
    },
  },
  confirmation: {
    title: {
      title: 'Acquistare la gift card?',
      subtitle_one: 'Vuoi acquistare 1 gift card per {{value}}?',
      subtitle_other: 'Vuoi acquistare {{count}} gift card per {{value}}?',
    },
    description: {
      total: 'Totale:',
      email: 'E-mail:',
      quantity: 'Quantità',
      amount: 'Importo',
    },
    footer: {
      cancel: 'Annulla',
      confirm: 'Conferma',
    },
  },
};
